import "./ExcelDiffPage.css";

import React from "react";
import {DataLoadingStatus} from "shared/types/common";
import CustomFileUploader from "../components/CustomFileUploader";
import ExcelTable from "features/excelDiff/components/ExcelTable";
import useCustomDiff from "../hooks/useCustomDiff";

const CustomDiffPage = () => {
    const {
        file1Size, setFile1Size,
        file1Fname, setFile1Fname,
        file2Size, setFile2Size,
        file2Fname, setFile2Fname,
        dataLoadingStatus,
        comparisonStatus,
        checkedItems,
        handleCheckboxChange,
        filteredComparisonResult,
        isCompareDisabled,
        handleCompare,
    } = useCustomDiff();

    return (
        <div className="excel-diff-page">
            <div className="inputs-panel">
                <div className="inputs-container">
                    <CustomFileUploader position={1} currFileName={file1Fname} setCurrFileName={setFile1Fname} currFileLen={file1Size} setCurrFileLen={setFile1Size}/>
                    <CustomFileUploader position={2} currFileName={file2Fname} setCurrFileName={setFile2Fname} currFileLen={file2Size} setCurrFileLen={setFile2Size}/>
                </div>
                <div className="checkboxes-container">
                    <div className="checkbox-container">
                        <input
                            type="checkbox"
                            id="unmodified"
                            name="unmodified"
                            className="custom-checkbox white-checkbox"
                            checked={checkedItems.unmodified}
                            onChange={handleCheckboxChange}
                        />
                        <label htmlFor="unmodified" className="tooltip">
                            Show unmodified rows
                        </label>
                    </div>
                    <div className="checkbox-container">
                        <input
                            type="checkbox"
                            id="modified"
                            name="modified"
                            className="custom-checkbox blue-checkbox"
                            checked={checkedItems.modified}
                            onChange={handleCheckboxChange}
                        />
                        <label htmlFor="blue" className="tooltip">
                            Show modified (blue) rows
                        </label>
                    </div>
                    <div className="checkbox-container">
                        <input
                            type="checkbox"
                            id="new"
                            name="new"
                            className="custom-checkbox green-checkbox"
                            checked={checkedItems.new}
                            onChange={handleCheckboxChange}
                        />
                        <label htmlFor="green" className="tooltip">
                            Show new rows
                        </label>
                    </div>

                    <div className="checkbox-container">
                        <input
                            type="checkbox"
                            id="deleted"
                            name="deleted"
                            className="custom-checkbox red-checkbox"
                            checked={checkedItems.deleted}
                            onChange={handleCheckboxChange}
                        />
                        <label htmlFor="red" className="tooltip">
                            Show deleted rows
                        </label>
                    </div>
                </div>
                <div className="button-container">
                    <button className="button green-button"
                            disabled={isCompareDisabled}
                            onClick={handleCompare}>{"Compare"}
                    </button>
                </div>
            </div>
            <div className="table-container scrollable">
                {dataLoadingStatus === DataLoadingStatus.Loading ?
                    <p className="info-text">Fetching uploaded files...</p> : <></>}
                {comparisonStatus === DataLoadingStatus.Loading ?
                    <p className="info-text">It may take up to 5 minutes. Please, be patient and don't refresh the
                        page!</p> : <></>}
                {dataLoadingStatus === DataLoadingStatus.Error || comparisonStatus === DataLoadingStatus.Error ?
                    <p className="error-text">Network error occured! Please, reload the page and try
                        again...</p> : <></>}

                {filteredComparisonResult !== undefined ? <ExcelTable result={filteredComparisonResult}/> : <></>}
            </div>
        </div>
    );
}

export default CustomDiffPage;